import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("title", null, "Layer 1"),
      _createElementVNode("path", {
        transform: "rotate(180 12 12)",
        id: "move_to_previous_period_svg__svg_1",
        d: "m5,21c-0.55,0 -1.02083,-0.1958 -1.4125,-0.5875c-0.39167,-0.3917 -0.5875,-0.8625 -0.5875,-1.4125l0,-4l2,0l0,4l14,0l0,-14l-14,0l0,4l-2,0l0,-4c0,-0.55 0.19583,-1.02083 0.5875,-1.4125c0.39167,-0.39167 0.8625,-0.5875 1.4125,-0.5875l14,0c0.55,0 1.0208,0.19583 1.4125,0.5875c0.3917,0.39167 0.5875,0.8625 0.5875,1.4125l0,14c0,0.55 -0.1958,1.0208 -0.5875,1.4125c-0.3917,0.3917 -0.8625,0.5875 -1.4125,0.5875l-14,0zm5.5,-4l-1.4,-1.45l2.55,-2.55l-8.65,0l0,-2l8.65,0l-2.55,-2.55l1.4,-1.45l5,5l-5,5z"
      })
    ], -1)
  ]))]))
}
export default { render: render }